import { useMobile } from "@/hooks";
import trackClevertapEvents from "@/utils/trackClevertapEvents";
import { Toast } from "@monsterindia/global-ui-components";
import { Facebook } from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";

import {
  getSocialLinksData,
  postLinkSocialAccount,
  unLinkSocialAccount,
} from "@/components/settings/api/networkUtils";
import { linkAcccountsContent } from "@/components/settings/contents/LinkAccounts";

import HeaderContentToggle from "../../components/common/HeaderContentToggle";
import socialSignup from "./social-signup/social-signup";

function LinkAccounts() {
  const [toast, setToast] = useState({ text: "", type: "", show: false });
  const isMobile = useMobile();
  const [visibilityStates, setVisibilityStates] = useState<{
    [name: string]: boolean;
  }>({ facebook: false, google: false });

  const prepareSocialLinksData = (data: any) => {
    if (data?.socialProviders?.length) {
      let socialLinks = data.socialProviders;
      let newVisibility = { ...visibilityStates };
      socialLinks.forEach((provider: string) => {
        if (provider in newVisibility) {
          newVisibility[provider] = true;
        }
      });
      setVisibilityStates(newVisibility);
    }
  };

  useEffect(() => {
    const fetchSocialData = async () => {
      try {
        const response = await getSocialLinksData();
        prepareSocialLinksData(response);
      } catch (err: any) {
        console.error(err);
      }
    };
    let _confObj = {
      provider: "google",
      onSuccess: linkSocialAccount,
    };
    socialSignup.init(_confObj);
    fetchSocialData();
  }, []);
  const onUnLinkSocialAccount = async (type: string) => {
    let payload = {
      socialProvider: type,
    };
    try {
      const response = await unLinkSocialAccount(payload);
      if (response?.errorCode) {
        setToast({
          text:
            response?.errorMessage ||
            "An error occurred while unlinking the social account.",
          type: "error",
          show: true,
        });
      } else {
        setVisibilityStates((prevVisibilityStates) => ({
          ...prevVisibilityStates,
          [type]: false,
        }));
        setToast({
          text:
            response?.successMessage ||
            "The social account is successfully unlinked",
          type: "success",
          show: true,
        });
      }
    } catch (err: any) {
      setToast({
        text: err?.response?.data?.errorMessage || `Something went wrong`,
        type: "error",
        show: true,
      });
    }
  };

  const getSocialAccessToken = (type: string) => {
    if (type == "google") {
      const googleSignInButton = document.getElementById("googleSignIn");
      googleSignInButton ? googleSignInButton.click() : null;
    } else {
      var _confObj = {
        provider: type,
        onSuccess: linkSocialAccount,
      };
      socialSignup.doSocialLogin(_confObj);
    }
  };
  const linkSocialAccount = async (response: any) => {
    let params = {
      socialAccessToken: response?.authResponse?.accessToken,
      socialProvider: response?.provider,
    };

    try {
      if (response) {
        const APIresponse = await postLinkSocialAccount(params);
        if (APIresponse.status === 201 || APIresponse.status === 200) {
          setVisibilityStates((prevVisibilityStates) => ({
            ...prevVisibilityStates,
            [response?.provider]: true,
          }));
          trackClevertapEvents.eventPush("Settings Updated", {
            linkAccounts: response?.provider,
          });
          setToast({
            text: `Your ${response?.provider || "social"} profile has been linked successfully.`,
            type: "success",
            show: true,
          });
        }
      }
    } catch (err: any) {
      const errorMsg =
        err?.response?.data?.error?.message?.errorMessage ||
        "Something went wrong";
      setToast({
        text: errorMsg,
        type: "error",
        show: true,
      });
    }
  };

  const editVisibility = (type: string) => {
    let data = type.toLowerCase();
    if (!visibilityStates[data]) {
      getSocialAccessToken(data);
    } else {
      onUnLinkSocialAccount(data);
    }
  };
  return (
    <>
      <Toast
        timer={3000}
        showToast={toast.show}
        text={toast.text}
        type={toast.type}
        onClose={() => setToast({ ...toast, show: false })}
        width={isMobile ? "75" : "50"}
        position="top-center"
      />

      <span id="googleSignIn"></span>

      <div className="bg-surface-secondary flex flex-col gap-2 rounded-xl p-3">
        <div className="text-base font-semibold">Manage social accounts</div>
        <div className="background-white rounded-lg bg-white p-3">
          {linkAcccountsContent.map((element, id) => (
            <div
              className={`py-3 md:!py-4 ${id === 0 ? "border-border-moderate border-b" : ""} `}
              key={id}
            >
              <HeaderContentToggle
                key={element.name}
                heading={element.heading}
                headingStyles="font-normal"
                showToggle={element.showToggle}
                name={element.name}
                image={element.name === "google" ? element.image : undefined}
                imageHeight={26}
                imageWidth={26}
                isToggleChecked={visibilityStates[element.name]}
                setToggleVisibility={editVisibility}
              >
                {element.name === "facebook" && (
                  <Facebook
                    height={26}
                    width={26}
                    className="size-6 fill-[#1769FF]"
                  />
                )}
              </HeaderContentToggle>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
export default LinkAccounts;
